import { defineMessages } from 'react-intl';

export const REDUX_NAMESPACE = 'REVIEW';

export const BUILD_PROGRESS_PERCENT_OF_TOTAL = 0.8;
export const DOWNLOAD_PROGRESS_PERCENT_OF_TOTAL = 0.9;
export const PUBLISH_PROGRESS_PERCENT_OF_TOTAL = 0.1;
export const UPDATE_EDITION_PERCENT_OF_TOTAL = 0.1;
export const ZIP_VIDEO_PERCENT_OF_TOTAL = 0.1;
export const REVIEW_MODAL_PREVIEW_HEIGHT = 384;

export const PUBLISHER_PRODUCT_LABEL = defineMessages({
  DEFAULT: {
    defaultMessage: 'Story',
    description: 'Label for the Story Studio Story product',
  },
  SIMPLE_OR_ADVANCED_MODE: {
    defaultMessage: 'Video',
    description: 'Label for publishing a video',
  },
  SHOW_PUBLISHER: {
    defaultMessage: 'Episode',
    description: 'Label for the Story Studio Episode product',
  },
});

export const AD_GUIDELINES =
  'https://businesshelp.snapchat.com/en-US/article/top-snap-specs';
